import { Component, OnInit } from "@angular/core";
import { SafeResourceUrl } from "@angular/platform-browser";
import { ActivatedRoute } from "@angular/router";
import { BudgetService } from "src/app/services/budget/budget.service";
import { NotificationToastService } from "src/app/services/notification-toast.service";
import { PdfService } from "src/app/services/pdf.service";

@Component({
  selector: "app-budget-report",
  templateUrl: "./budget-report.component.html",
  styleUrls: ["./budget-report.component.css"],
})
export class BudgetReportComponent implements OnInit {
  safeResourceUrl: SafeResourceUrl;
  loading: boolean;
  widthExp = 1200;
  heightExp = 800;

  group: string;

  constructor(
    private budgetService: BudgetService,
    private activatedRoute: ActivatedRoute,
    private notificationToastService: NotificationToastService,
    private pdfService: PdfService
  ) {}

  async ngOnInit() {
    try {
      this.loading = true;
      this.group = this.activatedRoute.snapshot.paramMap.get("Group");
      const report = await this.budgetService.getReport(this.group);
      const pdfUrl = this.pdfService.base64ToPdfUrl(report.ReportBase64);
      this.safeResourceUrl = this.pdfService.pdfUrlToPdfSafeResourceUrl(pdfUrl);
    } catch (err) {
      this.notificationToastService.error(JSON.stringify(err.error), "Reporte");
    } finally {
      this.loading = false;
    }
  }

  sendMail() {
    this.notificationToastService.success("Se ha enviado el mail", "Envio de mails");
    this.budgetService.sendMail(this.group).catch((err) =>
      this.notificationToastService.error(
        "Error al enviar el mail " + JSON.stringify(err.error),
        "Envio de mails"
      )
    );
  }


  getSafeResourceUrl(): SafeResourceUrl {
    return this.safeResourceUrl;
  }

  finish() {
    history.back();
  }
}
